export const getApiBase = () => {
  const base = process.env.REACT_APP_FW_API;
  if (!base) return "";
  return base.replace(/\/$/, "");
};
